// extracted by mini-css-extract-plugin
module.exports = {"aboutProfile":"about-profile_aboutProfile__1mAEl","buttons":"about-profile_buttons__btYG_"};